const domainMap = {
  'myaccount.vtmarkets.com': 'www.vtmarkets.com', //Primary domain
  'myaccount.vtmarkets.net': 'www.vtmarkets.net',
  'myaccount.vtmarketsid.com': 'www.vtmarketsid.com',
  'myaccount.vtmarketsmy.com': 'www.vtmarketsmy.com',
  'myaccount.vtmarketsvie.com': 'www.vtmarketsvie.com',
  'myaccount.vtmarketsjp.com': 'www.vtmarketsjp.com',
  'myaccount.global-vtrader.com': 'www.global-vtrader.com',
  'myaccount.vglobaltrader.com': 'www.vglobaltrader.com',
  'myaccount.vtmarketsru.com': 'www.vtmarketsru.com',
  'myaccount.vtmarketsfr.com': 'www.vtmarketsfr.com',
  'myaccount.vtmarketsit.com': 'www.vtmarketsit.com',
  'myaccount.securevtmarketscn.com': 'www.vtmarketstrade.com',
  'myaccount.vtmarketsfxgcn.com': 'www.vtmarketsglobal.com',
  'myaccount.vtmarketskh.com': 'www.vtmarketskh.com',
}

const destinationMap = {
  'Client Agreement': '/files/VT_Markets_LLC_Client_Agreeement.pdf',
  'Best Execution Policy': '/files/VT_Markets_LLC_Best_Execution_Policy.pdf',
  'Conflicts of Interest Policy': '/files/VT_Markets_LLC_Conflicts_of_Interest_Policy.pdf',
  'Privacy Policy': '/files/VT_Markets_LLC_Privacy_Policy.pdf',
  'Risk Warning Notice': '/files/VT_Markets_LLC_Risk_Disclosure_Notice.pdf',
  Legal: '/regulation/',
  'Cookie Policy': '/cookie-policy/',
}

const documents = {
  getLink(documentName) {
    const domain = domainMap[window.location.hostname] || Object.values(domainMap)[0]

    if (destinationMap.hasOwnProperty(documentName)) {
      return `https://${domain}${destinationMap[documentName]}`
    }

    return ''
  },

  getDomain(hostname = window.location.hostname) {
    return domainMap[hostname] || Object.values(domainMap)[0]
  },
}

export default documents
